module.exports = __webpack_public_path__ + "img/Ohio Wesleyan University.55e2f997.png";